import React, {Component} from 'react';

class Zona extends Component{

	constructor(props){
		super(props);
		this.fecha = props.fecha;
		this.variedad = props.variedad;
		this.sector = props.sector;
		this.tuneles = props.tuneles;
		this.estado = props.estado;
		this.actID = props.actID;

		this.cambiarEstado = this.cambiarEstado.bind(this);
	}

	cambiarEstado(id, estado){
		this.props.cambiarEstado(id, estado);
	}

	render(){
	const isTuneles = this.tuneles;
		return (
			<>
				<td> {this.sector} </td>
				<td> {this.variedad} </td>
				<td> 
				{isTuneles
				?	this.tuneles.map((tunel,index)=>{ 
						return (
							<div key={index}>
								Tunel {index +1} = {tunel} m
							</div>
						)
					})
				: <div>Completar</div>
				} 
				</td>
			</>
		);
	}
}

export default Zona;